<template>
  <component
    :is="isCartPage ? 'a' : 'button'"
    :aria-label="cartTitleText"
    :href="isCartPage ? cartURL : null"
    @click="!isCartPage && handleClick()"
  >
    <icon-cart />

    <span
      v-show="cartData.item_count > 0"
      class="cart-quantity count-pill"
      v-html="cartData.item_count"
    />
  </component>
</template>

<script>

/**
 * Site header component: Cart button
 * ------------------------------------------------------------------------------
 * - Cart button displayed in the site header.
 * - Renders as a link element on the cart page, and as a button anywhere else.
 */
import { mapState } from 'pinia'

import { useCartStore } from '~stores/cart'

import IconCart from '~icons/header/icon-cart.svg'

export default {
  name: 'CartButton',

  components: {
    IconCart,
  },

  computed: {

    /**
     * Map the cart data.
     */
    ...mapState(useCartStore, ['cartData']),

    /**
     * Calculate the 'Cart' text.
     * @returns {String}
     */
    cartTitleText() {
      return mint.strings.cart.title
    },

    /**
     * Calculate URL to the cart page
     * @returns {String}
     */
    cartURL() {
      return mint.routes.cart.url
    },

    /**
     * Return true if the user is on the cart page.
     * @returns {Boolean}
     */
    isCartPage() {
      return mint.request.pageType === 'cart'
    },
  },

  methods: {

    /**
     * Handle click events for the cart button.
     */
    handleClick() {
      mint.EventBus.dispatch('cartDrawer:toggle')
    },
  },
}
</script>
